import FingerprintJS from "@fingerprintjs/fingerprintjs";

// Pre-load FingerprintJS to speed up the first call
const fpPromise = FingerprintJS.load();

const generateDeviceId = async () => {
    // If already in localStorage, return it immediately
    const cachedId = localStorage.getItem("deviceId");
    if (cachedId) return cachedId;

    const fp = await fpPromise;
    const result = await fp.get();

    const deviceId = result.visitorId;  
    console.log("Device ID generated: ", deviceId);

    localStorage.setItem("deviceId", deviceId);
    return deviceId;
};
export default generateDeviceId;